import React, {useState} from 'react';
import {Button, Card, Col, Form, Input, message, Row} from 'antd';
import {LockOutlined, MailOutlined, UserOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';

import userApi from 'api/userApi';

const SignupPage = ({ onSuccess, onLoginClick }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      // passwordConfirm 필드는 API 호출에서 제외하고, 백엔드 필드명에 맞게 변경
      const { lgnUserNm, password, userName, email } = values;
      const userData = {
        lgnUserNm,
        userNm: userName, // userName -> userNm
        eml: email,       // email -> eml
        pswd: password    // password -> pswd
      };
      await userApi.signup(userData);
      message.success('회원가입이 완료되었습니다.');
      form.resetFields();
      if (onSuccess) {
        onSuccess();
      } else {
        navigate('/home', { replace: true });
      }
    } catch (error) {
      console.error('회원가입 실패:', error);
      // 에러 토스트는 공통 인터셉터에서 처리
    } finally {
      setLoading(false);
    }
  };

  const handleLoginClick = () => {
    if (onLoginClick) {
      onLoginClick();
      return;
    }
    try {
      window.dispatchEvent(new CustomEvent('open-login-modal'));
    } catch (e) { /* ignore */ }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f0f2f5'
    }}>
      <Card
        title="회원가입"
        style={{ width: 400, boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
        headStyle={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold' }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            name="lgnUserNm"
            label="로그인사용자명"
            rules={[
              { required: true, message: '로그인사용자명을 입력해주세요.' },
              { min: 3, message: '최소 3자 이상 입력해주세요.' },
              { max: 20, message: '최대 20자까지 입력 가능합니다.' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="로그인사용자명"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="비밀번호"
            rules={[
              { required: true, message: '비밀번호를 입력해주세요.' },
              { min: 6, message: '최소 6자 이상 입력해주세요.' },
              { max: 20, message: '최대 20자까지 입력 가능합니다.' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="비밀번호"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="passwordConfirm"
            label="비밀번호 확인"
            dependencies={['password']}
            rules={[
              { required: true, message: '비밀번호 확인을 입력해주세요.' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="비밀번호 확인"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="userName"
            label="사용자명"
            rules={[
              { required: true, message: '사용자명을 입력해주세요.' },
              { max: 50, message: '최대 50자까지 입력 가능합니다.' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="사용자명"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="이메일"
            rules={[
              { required: true, message: '이메일을 입력해주세요.' },
              { type: 'email', message: '올바른 이메일 형식을 입력해주세요.' }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="이메일"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              size="large"
              block
              style={{ marginBottom: '12px' }}
            >
              회원가입
            </Button>
          </Form.Item>

          <Row justify="center">
            <Col>
              이미 계정이 있으신가요?{' '}
              <Button
                type="link"
                onClick={handleLoginClick}
                style={{ padding: 0 }}
              >
                로그인
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default SignupPage;
